import React from 'react';

const GlassConfigTotalCell = ({ label, value }) => {
	if (!label || !value) return null;

	return (
		<div className="glass_config_total__cell">
			<div className="glass_config_total__title">{label}</div>
			<div className="glass_config_total__value">{value}</div>
		</div>
	);
};

export default GlassConfigTotalCell;
